import type { PublicApiKey } from '#packages/apilib';
import type { createSpotlightStageApi } from './spotlightStageApi';

export const SpotlightStageApiKey: PublicApiKey<
  typeof createSpotlightStageApi
> = {
  name: 'SpotlightStageApi',
  public: true,
};
